import { defineComponent, computed } from "vue";
import LanguageSelector from "./index.vue";
export default defineComponent({
    props: {
        config: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        }
    },
    components: {
        LanguageSelector: LanguageSelector
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var languageModel = computed({
            get: function() {
                return props.model[props.config.prop];
            },
            set: function(val) {
                emit("update-field", {
                    prop: props.config.prop,
                    value: val
                });
            }
        });
        return {
            languageModel: languageModel
        };
    }
});
